import '../../styles/base.less';
import '../../badge/style/index.less';
import '../../icon/style/index.less';
import '../../loading/style/index.less';
import '../../button/style/index.less';
import '../../action-bar/style/index.less';
import '../../overlay/style/index.less';
import '../../popup/style/index.less';
import './index.less';